import { render, staticRenderFns } from "./ThirdBlockOptions.vue?vue&type=template&id=74bea7f8&scoped=true"
import script from "./ThirdBlockOptions.vue?vue&type=script&lang=js"
export * from "./ThirdBlockOptions.vue?vue&type=script&lang=js"
import style0 from "./ThirdBlockOptions.vue?vue&type=style&index=0&id=74bea7f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bea7f8",
  null
  
)

export default component.exports